<template lang="pug">
div(class="flex flex-col gap-10")
    template(v-for="item in items")
        CartItem(
            :key="item.lineId"
            :item="item"
        )

</template>

<script>
import CartItem from './cartItem'

export default {
    name: 'Cart',
    components: {
        CartItem,
    },
    computed: {
        items() {
            return this.$store.state.cart.data?.items || []
        },
    },
}
</script>
